export default __webpack_public_path__ + "static/media/nonrefund.c4adfdab.svg";